const menuItems = [
  {
    color: "#fca2fd",
    title: "Головна",
    link: "/",
  },
  {
    title: "Результати",
    link: "/results",
  },
  {
    title: "Медіа",
    link: "/videos",
  },
  {
    title: "Зала Слави",
    link: "/hall-of-fame",
  },
  {
    title: "Пілоти",
    link: "/drivers",
  },
];

export default menuItems;
